import { observable } from "mobx";
import { Type } from "class-transformer";
import CounterpartyBankAccountResponse from "./counterpartyBankAccountResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RefundOriginalTransferPaymentResponse {
  @observable
  variableSymbol?: number;

  @observable
  @Type(() => Date)
  postingDate!: Date;

  @observable
  @Type(() => CounterpartyBankAccountResponse)
  senderBankAccount!: CounterpartyBankAccountResponse;

  @observable
  paidAmount!: number;
}
